import { useState, useEffect } from 'react';
import { getAuctionUrls } from '../api/bearcatApiService';

/**
 * Custom hook to manage auction URLs
 * @returns {Object} Object containing auction URLs and loading state
 */
export const useAuctionUrls = () => {
  const [auctionUrls, setAuctionUrls] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAuctionUrls = async () => {
      try {
        setLoading(true);
        setError(null);
        const urls = await getAuctionUrls();
        setAuctionUrls(urls);
      } catch (err) {
        setError(err);
        console.error('Failed to fetch auction URLs:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchAuctionUrls();
  }, []);

  return {
    auctionUrls,
    loading,
    error,
    refetch: () => {
      setLoading(true);
      setError(null);
      getAuctionUrls()
        .then(setAuctionUrls)
        .catch(setError)
        .finally(() => setLoading(false));
    }
  };
};

/**
 * Utility function to get specific auction URL
 * @param {Object} auctionUrls - The auction URLs object
 * @param {string} urlType - The type of URL to retrieve (e.g., 'base', 'myaccount', 'register', 'search')
 * @returns {string} The requested URL
 */
export const getAuctionUrl = (auctionUrls, urlType = 'base') => {
  if (!auctionUrls) {
    return '';
  }
  
  return auctionUrls[urlType] || auctionUrls.base || '';
};
